export let SPNToken = "0x1e840Ace41B258c9c4454f781d093f3e40EDC75a";
export let NFT = "0x8fe2C30E7547bDD3f81dE100f6419535cf622b87";
export let Dugout = "0x8A2339FA3efc89e40d2c95016658e030107cb051";